import { render } from "./DictionaryFieldForm.vue?vue&type=template&id=e2f1323e"
import script from "./DictionaryFieldForm.vue?vue&type=script&lang=js"
export * from "./DictionaryFieldForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__